import { LegalClientEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import { parseBaseGeneralValue } from 'modules/client/common/helpers';

import { GeneralFormType } from '../../forms/generalForm';

export const parseGeneralValue = (client: LegalClientEntity, t: TFunc) => {
  const values: GeneralFormType['general'] = {
    ...parseBaseGeneralValue(client, t),
    economicSector: client.economicSector
      ? {
          label: t(
            `client.legal.generalSection.economicSector.types.${client.economicSector}`
          ),
          value: client.economicSector,
        }
      : null,

    category: client.category
      ? {
          label: t(
            `client.legal.generalSection.category.@types.${client.category}`
          ),
          value: client.category,
        }
      : null,

    clientType: client.clientType
      ? {
          label: t(
            `client.client.generalSection.clientType.types.${client.clientType}`
          ),
          value: client.clientType,
        }
      : null,

    classification: client.classification
      ? {
          label: t(
            `client.client.generalSection.classification.types.${client.classification}`
          ),
          value: client.classification,
        }
      : null,

    isInsider: yesOrNotOption(t, client.isInsider) ?? null,
  };

  return values;
};
